export default class FeedbackReviewedModalCtrl{
  constructor($scope,	$cookies, $mdDialog, WorkPlanModalSrv, WorkPlanSrv, GlobalSrv, GlobalConfig){

    var vm = this
    const sharedVar = WorkPlanModalSrv.getVariable()
    
    // Variables declaradas
    vm.comment = ''

    // methods
    $scope.close = close
    $scope.feedback = feedback
    $scope.toggleSubcategories = toggleSubcategories

    activate()
 
    function close(){
      return $mdDialog.hide()
    }

    function activate(){
      $scope.activities = sharedVar.data
    }

    function getNotify(notificationId,comment){
      let description = 'Profesor: su plan de trabajo requiere ajustes. Por favor modifique su plan de acuerdo a las observaciones del revisor: '
      description = description + comment
      let data = {
            idUser:  sharedVar.userId,
            dsName: 'Notificación, retroalimentar plan de trabajo',
            dsDescription: description,
            idNotification_delivery_type: notificationId,
            is_grouped: 0
          }

      GlobalSrv.sendNotification(data)
    }

    function feedback(comment){
      let post = {
        teacherId: sharedVar.teacherId,
        workplanId: sharedVar.workplanId,
        comment: comment
      }
      WorkPlanSrv.updateFeedbackActivate.update(post).$promise.then(dataReturn => {
        if (dataReturn.status) {
           getNotify(GlobalConfig.notificationType.email,comment)
           getNotify(GlobalConfig.notificationType.inbox,comment)
           showModalSuccess()
        }
      },
        data => {
          console.log(data)
        }
      )
      return $mdDialog.hide()
    }

    function showModalSuccess() {
      $mdDialog.show({
        controller: ['$scope', '$mdDialog', function showModalSuccess($scope, $mdDialog) {
          $scope.name = sharedVar.teacherName
          $scope.close = function() {
            $mdDialog.hide() 
          }
        }],
        template: require('./feedbackSavefeedbackModal.html'),
        clickOutsideToClose:false
      })
    }

    function toggleSubcategories (module) {
      if (module.showChilds) {
        module.showChilds = false
      } else {
        module.showChilds = true
      }
    }


  }
}

FeedbackReviewedModalCtrl.$inject = ['$scope', '$cookies', '$mdDialog', 'WorkPlanModalSrv', 'WorkPlanSrv', 'GlobalSrv', 'GlobalConfig']



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/partials/review/summary/modals/feedbackReviewedModalCtrl.js